import React from 'react'

import headerImg01 from 'app/assets/icons/header-img-01.png'

const OwnerDecline = ({
  declineReason,
  description,
  update,
  updateNumber,
  decline,
  disabled,
}) => {
  let details = (
    <div>
      <p className="mb10">
        Can you please give us a bit more detail in the comment section below?
      </p>
      <div className="input-box mb30">
        <textarea required rows="4" onChange={update('description')}></textarea>
        <label>Please provide more details</label>
      </div>
    </div>
  )
  return (
    <div className="two-col-box-flex-row sm64">
      <div className="col-first">
        <div className="ilustration-box">
          <img src={headerImg01} />
        </div>

        <h3 className="mb25">
          Why are you declining this BondCover application?
        </h3>

        <label className="block mb15">
          <input
            type="radio"
            name="manager"
            value="1"
            onClick={updateNumber('declineReason')}
          />
          <span>The renter/lease details are wrong</span>
        </label>

        <label className="block mb15">
          <input
            type="radio"
            name="manager"
            value="2"
            onClick={updateNumber('declineReason')}
          />
          <span>My renter isn't suitable for BondCover</span>
        </label>

        <label className="block mb15">
          <input
            type="radio"
            name="manager"
            value="3"
            onClick={updateNumber('declineReason')}
          />
          <span>I don't have enough information about BondCover</span>
        </label>

        <label className="block mb30">
          <input
            type="radio"
            name="manager"
            value="5"
            onClick={updateNumber('declineReason')}
          />
          <span>Other</span>
        </label>

        {declineReason === 1 || declineReason === 5 ? details : ''}

        <button disabled={disabled} onClick={decline}>
          Submit <i className={disabled ? 'fa fa-spinner fa-pulse' : ''} />
        </button>

        <p className="fs12 mt25 mb0 gray-color">
          Your answer will only be visible to Snug
        </p>
      </div>
    </div>
  )
}

export default OwnerDecline
